import { render, staticRenderFns } from "./SelectTag.vue?vue&type=template&id=7522a564"
import script from "./SelectTag.vue?vue&type=script&lang=js"
export * from "./SelectTag.vue?vue&type=script&lang=js"
import style0 from "./SelectTag.vue?vue&type=style&index=0&id=7522a564&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports